import React, { useEffect, useState } from 'react'
import MySelect from '../../../../UI/form/MySelect'
import { useDispatch, useSelector } from 'react-redux'
import { editSupplyBillsItemsFiltersAgreeNachSupply } from '../../../../../store/supplyBillSlice'

const SupplyBillItemsAllFilterAgreeNachSupply = () => {

	const agree = useSelector(state => state.supplyBill.supplyBillsItemsAll.filters.agreeNachSupply)
	const dispatch = useDispatch()

  	const [value, setValue] = useState(agree)
  	const [validSelect, setValidSelect] = useState(false)
	const [options, setOptions] = useState([
		{
			id: 'yes',
			name: 'Так'
		},
		{
			id: 'no',
			name: 'Ні'
		},
		{
			id: 'other',
			name: 'Немає'
		},
		{
			id: 'all',
			name: 'Всі'
		},
	])

  return (
    <MySelect
        value={value}
        label="Погодження начальником"
        labelId="select__filterAgreeNachSupply-label"
        id='select__filterAgreeNachSupply'
        onChange = {e => {
            setValue(e)
			dispatch(editSupplyBillsItemsFiltersAgreeNachSupply(e))
			// setEvent({...event, categoryId: e})
		}}
        nameField='Погодження начальником'
        // sx={{width: '200px'}}
        options={
			options && options.length > 0 ? 
				options.map(option => {
            		return {id: option.id, name: option.name}
				})
			: []	
		}
        // options={[]}
    />
  )
}

export default SupplyBillItemsAllFilterAgreeNachSupply